var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14511 17.3586C10.0618 17.3586 10.8049 16.6155 10.8049 15.6988C10.8049 14.7822 10.0618 14.0391 9.14511 14.0391C8.22845 14.0391 7.48535 14.7822 7.48535 15.6988C7.48535 16.6155 8.22845 17.3586 9.14511 17.3586Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7144 17.3586C15.6311 17.3586 16.3742 16.6155 16.3742 15.6988C16.3742 14.7822 15.6311 14.0391 14.7144 14.0391C13.7978 14.0391 13.0547 14.7822 13.0547 15.6988C13.0547 16.6155 13.7978 17.3586 14.7144 17.3586Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36282 1.86825H3.66998L6.341 11.2187L6.1315 11.6376C5.57987 12.7397 6.38065 14.0397 7.6162 14.0397H16.9276C17.2334 14.0397 17.4808 13.7923 17.4808 13.4865C17.4808 13.1807 17.2334 12.9332 16.9276 12.9332H7.6162C7.20536 12.9332 6.93685 12.5006 7.1213 12.1325L7.27422 11.8267H16.9276C17.1745 11.8267 17.3917 11.6631 17.4598 11.4253L19.6728 3.67982C19.7203 3.51288 19.6868 3.33348 19.5825 3.19465C19.4777 3.05634 19.314 2.97475 19.1406 2.97475H5.13683L4.61925 1.16316C4.55116 0.925444 4.33399 0.761719 4.08706 0.761719H1.36282C1.05702 0.761719 0.80957 1.00917 0.80957 1.31497C0.80957 1.62077 1.05702 1.86825 1.36282 1.86825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.d0814afe637221b91a954d59d09e0892.svg";
export { ForwardRef as ReactComponent };